import { isEmpty, fireAnalyticsEvent } from '@myap/ui-library'
import useStudentInfo from './useStudentInfo'
import { USER_PROMPT_MODAL_ACTION } from '../components/scoresend/constants'

const useAnalyticsStudentScoreSendSuccessEvent = ({ userPromptType, loading, scoreSendSaved }) => {
  const { appUser } = useStudentInfo()

  useEffect(() => {
    if (
      !isEmpty(appUser) &&
      userPromptType === USER_PROMPT_MODAL_ACTION &&
      !loading &&
      scoreSendSaved
    ) {
      fireAnalyticsEvent({
        testing: false,
        disabled: false,
        eventData: {
          appUser,
          appPage: {
            domain: 'student',
            page: 'success',
            view: '',
            group: 'free-score-send',
          },
        },
      })
    }
  }, [appUser, userPromptType, loading, scoreSendSaved])

  return null
}

export default useAnalyticsStudentScoreSendSuccessEvent
